import { useQuery } from "react-query";

import { KindForTable } from "../../../utils/types";
import client from "../../Client";

export const fetchTenLatestProductKinds = async (shopGroupId: string) => {
    if (!shopGroupId) {
        return [];
    }

    const res = await client.get(`/v1/kinds?shop_group_id=${shopGroupId}&limit=10&sort=-modified_at`);
    return res.data;
};

export const useFetchLatestProductKindsQuery = (shopGroupId: string) => {
    return useQuery(["latest-product-kinds", shopGroupId], {
        queryFn: () => fetchTenLatestProductKinds(shopGroupId),
        enabled: !!shopGroupId,
        select: (data) => {
            if (!data || data.length === 0) return [];
            return data.map((item: KindForTable) => ({
                name: item.name,
                last_modified: item.modified_at,
                href: `/view/cannabis/${item.id}`,
            }));
        },
    });
};
